import type { IconDef } from '../types';

export const downChevron: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M0 6.0025C0 5.7425 0.1 5.4925 0.29 5.2925C0.68 4.9025 1.32 4.9025 1.71 5.2925L12 15.5925L22.29 5.2925C22.68 4.9025 23.31 4.9025 23.7 5.2925C24.09 5.6825 24.09 6.3125 23.7 6.7025L12.71 17.7125C12.52 17.9025 12.27 18.0025 12 18.0025C11.73 18.0025 11.48 17.8925 11.29 17.7125L0.29 6.7125C0.09 6.5125 0 6.2625 0 6.0025Z',
    },
  ],
};
